import { render, staticRenderFns } from "./AntInput.vue?vue&type=template&id=0681e05c&scoped=true"
import script from "./AntInput.vue?vue&type=script&lang=js"
export * from "./AntInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0681e05c",
  null
  
)

export default component.exports